import React from 'react';
import EshopItem from '@mshops-components-library/eshop-item';
import withAddToCart from '../../adapters/withAddToCart';

const EshopsItemCart = (props) => (
  <EshopItem {...props} />
);

export default withAddToCart(EshopsItemCart);
